var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTestTube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6859 3.11757L23.1993 9.14972M12.6859 3.11757L3.81366 18.4318C2.13866 21.3229 3.13269 25.0198 6.03386 26.689C8.93504 28.3583 12.6448 27.3676 14.3198 24.4765L16.1889 21.2503M12.6859 3.11757L11.641 2.49988M23.1993 9.14972L20.3775 14.0203M23.1993 9.14972L24.25 9.75455M16.1889 21.2503L18.2357 17.7171M16.1889 21.2503L12.923 19.3713M20.3775 14.0203L18.2357 17.7171M20.3775 14.0203L17.18 12.1805M18.2357 17.7171L12.9821 14.6944",
    stroke: "#1A2A6C",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18.6457C28 20.0839 26.8807 21.2498 25.5 21.2498C24.1193 21.2498 23 20.0839 23 18.6457C23 17.7458 23.9788 16.5447 24.7114 15.7717C25.1451 15.3141 25.8549 15.3141 26.2886 15.7717C27.0212 16.5447 28 17.7458 28 18.6457Z",
    stroke: "#1A2A6C",
    strokeWidth: 1.875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTestTube);
export default __webpack_public_path__ + "static/media/icon-test-tube.3567a0b81829a96f8bc8234e28966c57.svg";
export { ForwardRef as ReactComponent };